import AppConstants from "./AppConstants";

export function matchesExpiryFilters(filters: {
    showToday: boolean;
    showTomorrow: boolean;
    showWeek: boolean;
    showMonth: boolean;
    showNextMonth: boolean;
    showRest: boolean;
    showAll: boolean;
}, minExpiry: number) {
    // If "All" is checked, show everything
    if (filters.showAll) {
        return true;
    }
    
    let now = Date.now();
    let dif = (minExpiry - now) / AppConstants.DAY;
    
    // Check each enabled filter with OR logic
    if (filters.showToday && dif <= 1) return true;
    if (filters.showTomorrow && dif > 1 && dif <= 2) return true;
    if (filters.showWeek && dif <= 7) return true;
    if (filters.showMonth && dif <= 30) return true;
    if (filters.showNextMonth && dif > 30 && dif <= 60) return true;
    if (filters.showRest && dif > 60) return true;
    
    return false;
}

export class TimeUtil {
    static toYYYYMMDD(date: Date): string {
        if (!date) return '';
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${year}-${month}-${day}`;
    }

    static fromYYYYMMDD(dateStr: string): Date {
        if (!dateStr) {
            const d = new Date();
            d.setHours(0,0,0,0);
            return d;
        }
        const [year, month, day] = dateStr.split('-').map(Number);
        const d = new Date(year, month - 1, day);
        d.setHours(0,0,0,0);
        return d;
    }

    static toUIDate(date: Date): string {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    }

    static parseUIDate(dateStr: string): Date | null {
        if (!/^\d{2}-\d{2}-\d{4}$/.test(dateStr)) return null;
        const [day, month, year] = dateStr.split('-').map(Number);
        const d = new Date(year, month - 1, day);
        if (d.getFullYear() === year && d.getMonth() === month - 1 && d.getDate() === day) {
            return d;
        }
        return null;
    }

    static fromNano(nano: number): string {
        return new Date(nano / 1000000).toLocaleTimeString();
    }
}


